
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 30.8c7.622 0 13.8-6.178 13.8-13.8 0-7.622-6.178-13.8-13.8-13.8C9.378 3.2 3.2 9.378 3.2 17c0 7.622 6.178 13.8 13.8 13.8z","fill":"#FF4F4F"}}),_c('path',{attrs:{"d":"M22.9 22.7l.3-4c.1-.7-.3-1.1-.8-1.3-.6 0-1.1.4-1.1.9l-.1 1.8-8.6-8.6-.3-.3c-.4-.4-1.1-.4-1.4 0-.4.4-.4 1.1 0 1.4l2.7 2.7 6.2 6.2-1.8.1c-.6 0-.9.5-.9 1.1 0 .3.1.4.4.6.3.2.5.4.8.4l4-.3c.1-.1.1 0 .2-.1l.1-.1.1-.1.1-.1.1-.1.1-.1c-.1 0-.1 0-.1-.1z","fill":"#fff"}})])
          )
        }
      }
    